import HTMLEntitiesMap from './HTMLEntitiesMap';

type htmlEntitiesKey = keyof typeof HTMLEntitiesMap;

// Reverse the keys and values for decoding
const reverseHtmlEntities = Object.fromEntries(
  Object.entries(HTMLEntitiesMap).map(
    ([key, value]) =>
      [value, key] as [typeof HTMLEntitiesMap[htmlEntitiesKey], htmlEntitiesKey]
  )
);

/**
 * @example encodeToHTMLEntities('Hòm nhĩ trái') -> H&ograve;m nhĩ tr&aacute;i
 */
export function encodeToHTMLEntities(str, exclude: htmlEntitiesKey[] = []) {
  // Filter out keys that are in the exclude array
  const charactersToEncode = Object.keys(HTMLEntitiesMap)
    .filter((key) => !exclude.includes(key))
    .join('');

  // Create a regular expression from the filtered character list
  const regex = new RegExp(`[${charactersToEncode}]`, 'gi');

  return str.replace(regex, function (match) {
    return HTMLEntitiesMap[match] || match;
  });
}

/**
 * @example decodeHTMLEntities('H&ograve;m nhĩ tr&aacute;i') -> Hòm nhĩ trái
 */
export function decodeHTMLEntities(str = '', exclude: htmlEntitiesKey[] = []) {
  if (typeof str !== 'string') {
    console.error('Input must be a string', str);
    return;
  }

  // Filter out values that are in the exclude array
  const entitiesToDecode = Object.keys(reverseHtmlEntities)
    .filter((key) => !exclude.includes(reverseHtmlEntities[key]))
    .join('|');

  // Create a regular expression from the filtered entity list
  const regex = new RegExp(`(${entitiesToDecode})`, 'gi');

  return str.replace(regex, (match) => reverseHtmlEntities[match] || match);
}

/* export const encodedStr = (str) =>
  str.replace(/[\u00A0-\u9999<>\&]/g, function (i) {
    return '&#' + i.charCodeAt(0) + ';';
  }); */
